// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1__d6a06c57ca6c081185d9","cls2":"RatingCard-cls2___174c19f96303fac1db9 RatingCard-cls1__d6a06c57ca6c081185d9"};